import _axios from '@/utils/request'

export function getInfo() {
    return _axios('get', `/ms-shulan-hospital/v1/account`)
}

export function getDictionary() {
    const param = {
        dictDataValue: '',
        dictTypeValue: ''
    }
    return _axios('post', `/ms-shulan-hospital/v1/dictionary/listAll`, param)
}
export function getAddress(param) {
    return _axios('post', `/ms-shulan-hospital/v1/address/listAddress`, param)
}

// 用户列表 - 获取验证码
export function postSendVerification(param) {
    return _axios('post', `/ms-shulan-hospital/v1/doctor/sendChangeVerification`, param)
}

// 用户列表 -  修改密码
export function putChangePassword(params) {
    return _axios('put', `/ms-shulan-hospital/v1/doctor/changePassword`, params)
}

// 是否可以关联此手机号
export function getIsCanBindPhone(iuid, phone) {
    return _axios('get', `/ms-shulan-hospital/v1/doctor/isCanBindPhone?iuid=${iuid}&phone=${phone}`)
}
// 绑定手机
export function postBindPhone(iuid, phone) {
    return _axios('post', `/ms-shulan-hospital/v1/doctor/bindPhone?iuid=${iuid}&phone=${phone}`, {}, 'specialurl')
}

// 合并账号 web端调用
export function postMergeAccount(iuid, phone) {
    return _axios('post', `/ms-shulan-hospital/v1/doctor/mergeAccount?iuid=${iuid}&phone=${phone}`, {}, 'specialurl')
}
